import { deleteApi, getApi, postApi, putApi } from "../configAxios";

export const normalizeList = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export const getDivisions = () => getApi("/locations/divisions");

export const getCityCorporations = (params) =>
  getApi("/city-corporations", params);

export const createCityCorporation = (data) =>
  postApi("/city-corporations", data);

export const updateCityCorporation = (data) =>
  putApi("/city-corporations", data);

export const deleteCityCorporation = (id) =>
  deleteApi(`/city-corporations/${id}`);

export const getThanas = (params) => getApi("/thanas", params);

export const createThana = (data) => postApi("/thanas", data);

export const updateThana = (data) => putApi("/thanas", data);

export const deleteThana = (id) => deleteApi(`/thanas/${id}`);

export const getWards = (params) => getApi("/wards", params);

export const createWard = (data) => postApi("/wards", data);

export const updateWard = (data) => putApi("/wards", data);

export const deleteWard = (id) => deleteApi(`/wards/${id}`);
